document.addEventListener("DOMContentLoaded", function () {
  function initProductDescriptionToggle() {
    const container = document.getElementById("product-description-container");
    const toggle = document.getElementById("product-description-toggle");
    const btn = document.getElementById("product-description-btn");

    if (!container || !toggle || !btn) return;

    // Check if content height requires a toggle button
    if (container.scrollHeight > 244) {
      toggle.style.display = "flex";
    }

    // Toggle functionality
    btn.addEventListener("click", function () {
      if (container.classList.contains("collapsed")) {
        container.classList.remove("collapsed");
        btn.textContent = "Devamını Gizle";
      } else {
        container.classList.add("collapsed");
        btn.textContent = "Devamını Gör";

        const sectionHeader = container.closest('.ja-productpage-collapse-item').querySelector('.ja-productpage-collapse-item-header');
        if (sectionHeader) {
          sectionHeader.scrollIntoView({
            behavior: "auto",
            block: "center"
          });
        }
      }
    });
  }

  // Initialize on page load
  initProductDescriptionToggle();
});